<button class="option-button hover-pointer" (click)="toggleOptionMenu()">
	<icon [type]="iconType"></icon>
</button>
<div class="new-container-menu" *ngIf="showOptionMenu">
	<ng-content></ng-content>
</div>
